export class Validation {
  valid: boolean;
  message: string;

  constructor(valid: boolean, message?: string) {
    this.valid = valid;
    this.message = message || "ungültiger Wert";
  }
}